<header class="header-one header--sticky">
  <div class="header-top-one-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="header-top-one">
            <div class="left-information">
              <a href="mailto:secretaria@faculdadevincit.edu.br" class="email"
                ><i class="fa-solid fa-envelope"></i
                >secretaria@faculdadevincit.edu.br</a
              >
              <a href="tel:+5544984641888" class="email"
                ><i class="fa-solid fa-phone"></i>+55 (44) 98464-1888</a
              >
            </div>
            <div class="right-information">
              <ul class="rts-dropdown-menu switcher-currency">
                <li class="has-child-menu p-3">
                  <a [routerLink]="['/']">
                    <span class="menu-item"></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="header-one-wrapper">
          <div class="left-side-header">
            <a href="#" class="logo-area">
              <img
                src="assets/images/logo/logo-1.png"
                width="130"
                height="130"
                alt="logo"
              />
            </a>

            <div class="main-nav-one">
              <nav>
                <ul>
                  <li class="has-dropdown no-icon" style="position: static">
                    <a class="nav-link" href="#">Home</a>
                  </li>

                  <li class="has-dropdown" style="position: static">
                    <a class="nav-link" href="#">Cursos</a>
                    <ul class="megamenu-hub min-mega shape-move">
                      <li>
                        <ul class="">
                          <li class="parent"><a>Graduação</a></li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/administracao']"
                              >Administração</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/analise-e-desenvolvimento-de-sistemas'
                              ]"
                              >Análise e Desenvolvimento de Sistemas</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/direito']"
                              >Direito</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/engenharia-de-software']"
                              >Engenharia de Software</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/gestao-comercial']"
                              >Gestão Comercial</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/gestao-de-recursos-humanos'
                              ]"
                              >Gestão de Recursos Humanos</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/logistica']"
                              >Logística</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/marketing']"
                              >Marketing</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/pedagogia']"
                              >Pedagogia</a
                            >
                          </li>
                          <li>
                            <a
                              [routerLink]="['/cursos-graduacao']"
                              class="mobile-menu-link rts-btn btn-primary-white with-arrow"
                            >
                              Ver mais<i class="fa-solid fa-arrow-right"></i
                            ></a>
                          </li>
                        </ul>
                        <ul class="">
                          <li class="parent">
                            <a>Pós-Graduação</a>
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/arquitetura-de-software']"
                              >Arquitetura de Software</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/arquitetura-de-software-em-java'
                              ]"
                              >Arquitetura de Software em Java</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/arquitetura-de-solucoes-em-plataforma-dotnet'
                              ]"
                              >Arquitetura de Soluções em Plataforma.Net (C#)</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/business-intelligence']"
                              >Business Intelligence</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/computacao-em-nuvem-e-aplicativos-moveis'
                              ]"
                              >Computação em Nuvem e Aplicativos Móveis</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/computacao-forense-e-investigacao-cibernetica'
                              ]"
                              >Computação Forense e Investigação Cibernética</a
                            >
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/data-science-aplicada-a-gestao-e-tecnologia-da-informacao'
                              ]"
                              >Data Science aplicada a Gestão e Tecnologia da
                              Informação
                            </a>
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="['/cursos/defesa-cibernetica']"
                              >Defesa Cibernética
                            </a>
                          </li>
                          <li>
                            <a
                              class="mobile-menu-link"
                              [routerLink]="[
                                '/cursos/design-grafico-ux-e-multimidia'
                              ]"
                              >Design Gráfico, UX e Multimídia
                            </a>
                          </li>
                          <li>
                            <a
                              [routerLink]="['/cursos-pos-graduacao']"
                              class="mobile-menu-link rts-btn btn-primary-white with-arrow"
                            >
                              Ver mais<i class="fa-solid fa-arrow-right"></i
                            ></a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="has-dropdown">
                    <a class="nav-link" href="#">A Facint</a>
                    <ul class="submenu">
                      <li>
                        <a class="mobile-menu-link" [routerLink]="['/a-facint']"
                          >Sobre a Facint</a
                        >
                      </li>
                      <li>
                        <a class="mobile-menu-link" [routerLink]="['/sede']"
                          >Unidade Sede</a
                        >
                      </li>
                      <li>
                        <a class="mobile-menu-link" [routerLink]="['/polos']"
                          >Polos de Apoio Presencial</a
                        >
                      </li>
                      <li>
                        <a
                          class="mobile-menu-link"
                          [routerLink]="['/infraestrutura']"
                          >Infraestrutura</a
                        >
                      </li>
                      <li>
                        <a
                          class="mobile-menu-link"
                          [routerLink]="['/corpo-docente']"
                          >Corpo Docente</a
                        >
                      </li>
                      <li>
                        <a class="mobile-menu-link" href="#"
                          >Calendário Escolar</a
                        >
                      </li>
                      <li>
                        <a class="mobile-menu-link" href="#"
                          >Organograma da Faculdade</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="has-dropdown">
                    <a class="nav-link" href="#"
                      >Instituições do Grupo Facint</a
                    >
                    <ul class="submenu">
                      <li>
                        <a [routerLink]="['/facint-goiania']"
                          >Faculdade Facint Goiânia</a
                        >
                      </li>
                      <li>
                        <a [routerLink]="['/facintec']"
                          >Facintec – Escola Técnica</a
                        >
                      </li>
                      <li>
                        <a [routerLink]="['/eja']"
                          >Educação de Jovens e Adultos (EJA)</a
                        >
                      </li>
                      <li>
                        <a [routerLink]="['/atena-idiomas']">Atena Idiomas</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="header-right-area-one">
            <div class="buttons-area">
              <a
                href="https://portal.virtualfacint.com.br"
                class="rts-btn btn-border"
                >Portal do Aluno</a
              >
              <a
                href="https://matricula.virtualfacint.com.br"
                class="rts-btn btn-primary"
                >Inscreva-se</a
              >
            </div>
            <div class="menu-btn" id="menu-btn">
              <svg
                width="20"
                height="16"
                viewBox="0 0 20 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="14" width="20" height="2" fill="#1F1F25"></rect>
                <rect y="7" width="20" height="2" fill="#1F1F25"></rect>
                <rect width="20" height="2" fill="#1F1F25"></rect>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div id="side-bar" class="side-bar header-two">
  <button class="close-icon-menu"><i class="fa fa-times"></i></button>

  <div class="mobile-menu-main">
    <nav class="nav-main mainmenu-nav mt--30">
      <ul class="mainmenu metismenu" id="mobile-menu-active">
        <li class="has-dropdown no-icon" style="position: static">
          <a class="nav-link" href="#">Home</a>
        </li>

        <li class="has-dropdown" style="position: static">
          <a class="nav-link" href="#">Cursos</a>
          <ul class="megamenu-hub min-mega shape-move">
            <li>
              <ul class="">
                <li class="parent"><a>Graduação</a></li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/administracao']"
                    >Administração</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="[
                      '/cursos/analise-e-desenvolvimento-de-sistemas'
                    ]"
                    >Análise e Desenvolvimento de Sistemas</a
                  >
                </li>
                <li>
                  <a class="mobile-menu-link" [routerLink]="['/cursos/direito']"
                    >Direito</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/engenharia-de-software']"
                    >Engenharia de Software</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/gestao-comercial']"
                    >Gestão Comercial</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/gestao-de-recursos-humanos']"
                    >Gestão de Recursos Humanos</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/logistica']"
                    >Logística</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/marketing']"
                    >Marketing</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/pedagogia']"
                    >Pedagogia</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/cursos-graduacao']"
                    class="mobile-menu-link rts-btn btn-primary-white with-arrow"
                  >
                    Ver mais<i class="fa-solid fa-arrow-right"></i
                  ></a>
                </li>
              </ul>
              <ul class="">
                <li class="parent">
                  <a>Pós-Graduação</a>
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/arquitetura-de-software']"
                    >Arquitetura de Software</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/arquitetura-de-software-em-java']"
                    >Arquitetura de Software em Java</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="[
                      '/cursos/arquitetura-de-solucoes-em-plataforma-dotnet'
                    ]"
                    >Arquitetura de Soluções em Plataforma.Net (C#)</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/business-intelligence']"
                    >Business Intelligence</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="[
                      '/cursos/computacao-em-nuvem-e-aplicativos-moveis'
                    ]"
                    >Computação em Nuvem e Aplicativos Móveis</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="[
                      '/cursos/computacao-forense-e-investigacao-cibernetica'
                    ]"
                    >Computação Forense e Investigação Cibernética</a
                  >
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="[
                      '/cursos/data-science-aplicada-a-gestao-e-tecnologia-da-informacao'
                    ]"
                    >Data Science aplicada a Gestão e Tecnologia da Informação
                  </a>
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/defesa-cibernetica']"
                    >Defesa Cibernética
                  </a>
                </li>
                <li>
                  <a
                    class="mobile-menu-link"
                    [routerLink]="['/cursos/design-grafico-ux-e-multimidia']"
                    >Design Gráfico, UX e Multimídia
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['/cursos-pos-graduacao']"
                    class="mobile-menu-link rts-btn btn-primary-white with-arrow"
                  >
                    Ver mais<i class="fa-solid fa-arrow-right"></i
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="has-dropdown">
          <a class="nav-link" href="#">A Facint</a>
          <ul class="submenu">
            <li>
              <a class="mobile-menu-link" [routerLink]="['/a-facint']"
                >Sobre a Facint</a
              >
            </li>
            <li>
              <a class="mobile-menu-link" [routerLink]="['/sede']"
                >Unidade Sede</a
              >
            </li>
            <li>
              <a class="mobile-menu-link" [routerLink]="['/polos']"
                >Polos de Apoio Presencial</a
              >
            </li>
            <li>
              <a class="mobile-menu-link" [routerLink]="['/infraestrutura']"
                >Infraestrutura</a
              >
            </li>
            <li>
              <a class="mobile-menu-link" [routerLink]="['/corpo-docente']"
                >Corpo Docente</a
              >
            </li>
            <li>
              <a class="mobile-menu-link" href="#">Calendário Escolar</a>
            </li>
            <li>
              <a class="mobile-menu-link" href="#">Organograma da Faculdade</a>
            </li>
          </ul>
        </li>
        <li class="has-dropdown">
          <a class="nav-link" href="#">Instituições do Grupo Facint</a>
          <ul class="submenu">
            <li>
              <a [routerLink]="['/facint-goiania']">Faculdade Facint Goiânia</a>
            </li>
            <li>
              <a [routerLink]="['/facintec']">Facintec – Escola Técnica</a>
            </li>
            <li>
              <a [routerLink]="['/eja']">Educação de Jovens e Adultos (EJA)</a>
            </li>
            <li>
              <a [routerLink]="['/atena-idiomas']">Atena Idiomas</a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

    <div class="buttons-area">
      <a href="https://portal.virtualfacint.com.br" class="rts-btn btn-border"
        >Portal do Aluno</a
      >
      <a
        href="https://matricula.virtualfacint.com.br"
        class="rts-btn btn-primary"
        >Inscreva-se</a
      >
    </div>

    <div class="rts-social-style-one pl--20 mt--50 social-copyright">
      <ul>
        <li>
          <a href="https://www.facebook.com/faculdade.facint"
            ><i
              class="fa-brands fa-facebook-f"
              [ngStyle]="{ color: '#000000' }"
            ></i
          ></a>
        </li>
        <li>
          <a href="https://www.instagram.com/faculdade_facint"
            ><i
              class="fa-brands fa-instagram"
              [ngStyle]="{ color: '#000000' }"
            ></i
          ></a>
        </li>
        <li>
          <a href="https://www.linkedin.com/school/faculdadefacint"
            ><i
              class="fa-brands fa-linkedin"
              [ngStyle]="{ color: '#000000' }"
            ></i
          ></a>
        </li>
        <li>
          <a href="https://x.com/FaculdadeFacint"
            ><i
              class="fa-brands fa-twitter"
              [ngStyle]="{ color: '#000000' }"
            ></i
          ></a>
        </li>
        <li>
          <a href="https://www.youtube.com/c/FaculdadeVINCIT"
            ><i
              class="fa-brands fa-youtube"
              [ngStyle]="{ color: '#000000' }"
            ></i
          ></a>
        </li>
      </ul>
    </div>
  </div>
</div>
